import React from 'react'
    import { Search, FileText, CheckCircle } from 'lucide-react'

    const HowItWorksSection = () => {
      const steps = [
        {
          number: "01",
          icon: Search,
          title: "Consultation & Funding Analysis",
          description: "We identify the best capital option for your business through comprehensive analysis of your needs, credit situation, and growth goals."
        },
        {
          number: "02",
          icon: FileText,
          title: "Funding Preparation & Packaging",
          description: "We assemble documents, structure your file, prep your COI, and position you for approval with our network of alternative lenders."
        },
        {
          number: "03",
          icon: CheckCircle,
          title: "Approval & Capital Growth Plan",
          description: "We secure funding and build your next 30-day growth strategy to maximize the impact of your new capital."
        }
      ]

      return (
        <section id="how-it-works" className="py-20 bg-gray-50" data-component-path="client/src/components/HowItWorksSection.jsx" data-component-line="1:4" data-component-id="client/src/components/HowItWorksSection.jsx:1:4">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-component-path="client/src/components/HowItWorksSection.jsx" data-component-line="2:6" data-component-id="client/src/components/HowItWorksSection.jsx:2:6">
            <div className="text-center mb-16" data-component-path="client/src/components/HowItWorksSection.jsx" data-component-line="3:8" data-component-id="client/src/components/HowItWorksSection.jsx:3:8">
              <h2 className="text-3xl md:text-4xl font-bold text-black mb-6" data-component-path="client/src/components/HowItWorksSection.jsx" data-component-line="4:10" data-component-id="client/src/components/HowItWorksSection.jsx:4:10">
                How It Works
              </h2>
              <p className="text-lg text-gray-700 max-w-3xl mx-auto" data-component-path="client/src/components/HowItWorksSection.jsx" data-component-line="5:10" data-component-id="client/src/components/HowItWorksSection.jsx:5:10">
                Our proven 3-step process gets you from application to funding quickly and efficiently
              </p>
            </div>

            <div className="grid grid-cols-1 md:grid-cols-3 gap-8" data-component-path="client/src/components/HowItWorksSection.jsx" data-component-line="6:8" data-component-id="client/src/components/HowItWorksSection.jsx:6:8">
              {steps.map((step, index) => {
                const IconComponent = step.icon
                return (
                  <div key={index} className="text-center relative" data-component-path="client/src/components/HowItWorksSection.jsx" data-component-line="7:14" data-component-id="client/src/components/HowItWorksSection.jsx:7:14">
                    <div className="relative mb-8" data-component-path="client/src/components/HowItWorksSection.jsx" data-component-line="8:16" data-component-id="client/src/components/HowItWorksSection.jsx:8:16">
                      <div className="w-20 h-20 bg-white rounded-full flex items-center justify-center mx-auto shadow-lg border-4 border-gold" data-component-path="client/src/components/HowItWorksSection.jsx" data-component-line="9:18" data-component-id="client/src/components/HowItWorksSection.jsx:9:18">
                        <IconComponent className="text-gold" size={32} />
                      </div>
                      <div className="absolute -top-2 -right-2 w-8 h-8 bg-gold rounded-full flex items-center justify-center" data-component-path="client/src/components/HowItWorksSection.jsx" data-component-line="10:18" data-component-id="client/src/components/HowItWorksSection.jsx:10:18">
                        <span className="text-white font-bold text-sm" data-component-path="client/src/components/HowItWorksSection.jsx" data-component-line="11:20" data-component-id="client/src/components/HowItWorksSection.jsx:11:20">{step.number}</span>
                      </div>
                    </div>
                    
                    <h3 className="text-xl font-semibold text-black mb-4" data-component-path="client/src/components/HowItWorksSection.jsx" data-component-line="12:16" data-component-id="client/src/components/HowItWorksSection.jsx:12:16">{step.title}</h3>
                    <p className="text-gray-600 leading-relaxed" data-component-path="client/src/components/HowItWorksSection.jsx" data-component-line="13:16" data-component-id="client/src/components/HowItWorksSection.jsx:13:16">{step.description}</p>
                    
                    {index < steps.length - 1 && (
                      <div className="hidden md:block absolute top-10 left-full w-full h-0.5 bg-gold transform -translate-y-1/2 z-0" data-component-path="client/src/components/HowItWorksSection.jsx" data-component-line="14:18" data-component-id="client/src/components/HowItWorksSection.jsx:14:18"></div>
                    )}
                  </div>
                )
              })}
            </div>
          </div>
        </section>
      )
    }

    export default HowItWorksSection